import React from 'react';
import Modal from 'react-modal';
import { getCookie } from '../../inc/cookies';

import swal from 'sweetalert';
import config from '../../inc/config';

export default class CouponModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,

            providers: [],
            providerId: 0
        };
    }

    getProviders() {
        let sessionHash = getCookie('sessionHash');

        const requestOptions = {
            method: 'GET',
            headers: { 'Authorization': 'Bearer ' + sessionHash }
        };

        fetch(`${config.restApiExpertise}providers/tr?active=1`, requestOptions)
            .then(response => response.json())
            .then(responseData => {
                switch (responseData.status) {
                    case 200: {
                        this.setState({ isLoading: false, providers: responseData.data });
                    }
                        break;
                    case 401: {
                        this.props.setProvidersAuth(responseData.message);
                        //errorMessages.push(responseData.message)
                    }
                        break;
                    default: {
                        this.setState({ isLoading: false });

                        swal({
                            dangerMode: true,
                            icon: 'warning',
                            title: 'Hay Aksi',
                            text: responseData.message,
                            buttons: 'Tamam'
                        }).then(() => this.props.navigate('/home'));
                    }
                        break;
                }
            }, () => swal({ dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam' }));
    }

    saveAppraisalCouponProvidersOnClick = () => {
        let sessionHash = getCookie('sessionHash');
        this.setState({ isLoading: true });

        let infoMessage = '';
        if (!this.props.memberProductId) {
            infoMessage = 'Sağlayıcı Seçiniz !';
        }

        if (infoMessage) {
            swal({
                dangerMode: true,
                icon: 'info',
                title: 'Eksik Bilgi',
                text: infoMessage,
                buttons: 'Tamam'
            });
        } else {
            this.setState({ isLoading: true });

            const requestOptions = {
                method: 'POST',
                headers: { 'Authorization': 'Bearer ' + sessionHash, 'Content-Type': 'application/json' },
                body: JSON.stringify({ memberProductId: this.props.memberProductId, providerId: this.state.providerId })
            };

            fetch(config.restApi + 'createAppraisalCoupon/tr', requestOptions)
                .then(response => response.json())
                .then(responseData => {
                    switch (responseData.status) {
                        case 200: {
                            swal({
                                dangerMode: true,
                                icon: 'success',
                                title: 'Tamamlandı',
                                text: 'Kupon başarıyla gönderildi.',
                                buttons: 'Tamam'
                            }).then(() => { this.props.getMemberProducts(); this.setState({ isLoading: false, providerId: 0 }); this.props.onRequestClose(); });
                        }
                            break;
                        default: {
                            this.setState({ isLoading: false });

                            swal({
                                dangerMode: true,
                                icon: 'warning',
                                title: 'Hay Aksi',
                                text: responseData.message,
                                buttons: 'Tamam'
                            }).then(() => this.props.onRequestClose());
                        }
                            break;
                    }
                }, () => swal({ dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam' }));
        }
    }

    handleProviderChange = (event) => {
        const selectedprovider = parseInt(event.target.value);
        this.setState({ providerId: selectedprovider });
    };

    componentDidMount() {
        this.getProviders();
    }

    render() {
        return (this.state.isLoading ?
            <div className="ibox-content sk-loading position-static">
                <div className="sk-spinner sk-spinner-fading-circle">
                    <div className="sk-circle1 sk-circle"></div>
                    <div className="sk-circle2 sk-circle"></div>
                    <div className="sk-circle3 sk-circle"></div>
                    <div className="sk-circle4 sk-circle"></div>
                    <div className="sk-circle5 sk-circle"></div>
                    <div className="sk-circle6 sk-circle"></div>
                    <div className="sk-circle7 sk-circle"></div>
                    <div className="sk-circle8 sk-circle"></div>
                    <div className="sk-circle9 sk-circle"></div>
                    <div className="sk-circle10 sk-circle"></div>
                    <div className="sk-circle11 sk-circle"></div>
                    <div className="sk-circle12 sk-circle"></div>
                </div>
            </div>
            : <div className="modal inmodal">
                <div className="modal-dialog">
                    <div className="modal-content animated fadeIn">
                        <Modal
                            isOpen={this.props.isOpen}
                            onRequestClose={this.props.onRequestClose}
                            style={{
                                content: {
                                    position: 'null',
                                    top: 'null',
                                    left: 'null',
                                    right: 'null',
                                    bottom: 'null',
                                    border: 'none',
                                    background: '#fff',
                                    padding: 'null',
                                    maxWidth: '50%',
                                    minWidth: '350px'
                                },
                                overlay: {
                                    position: 'fixed',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: 'rgba(0,0,0,00.1)',
                                    zIndex: 2500
                                }
                            }}
                        >
                            {this.state.isLoading ?
                                <div className="ibox-content sk-loading position-static">
                                    <div className="sk-spinner sk-spinner-fading-circle">
                                        <div className="sk-circle1 sk-circle"></div>
                                        <div className="sk-circle2 sk-circle"></div>
                                        <div className="sk-circle3 sk-circle"></div>
                                        <div className="sk-circle4 sk-circle"></div>
                                        <div className="sk-circle5 sk-circle"></div>
                                        <div className="sk-circle6 sk-circle"></div>
                                        <div className="sk-circle7 sk-circle"></div>
                                        <div className="sk-circle8 sk-circle"></div>
                                        <div className="sk-circle9 sk-circle"></div>
                                        <div className="sk-circle10 sk-circle"></div>
                                        <div className="sk-circle11 sk-circle"></div>
                                        <div className="sk-circle12 sk-circle"></div>
                                    </div>
                                </div>
                                :
                                <>
                                    <div className="modal-header d-block text-center text-darkblue">
                                        <button className="close" onClick={this.props.onRequestClose}><span>×</span></button>
                                        <h4 className="modal-title">{this.props.modalTitle}</h4>
                                    </div>
                                    <div className="modal-body text-darkblue">
                                        {this.state.providers.map((provider, index) => (
                                            <div className="align-middle" key={index}>
                                                <div className="d-flex">
                                                    <label className="d-flex cursor">
                                                        <input className="mr-1" type="radio" id={`optionsRadios${provider.id}`} name="priority" onChange={this.handleProviderChange} value={provider.id} />
                                                        {provider.name}
                                                    </label>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="modal-footer">
                                        <button className="btn btn-orange" onClick={this.props.onRequestClose}>Kapat</button>
                                        <button className="btn btn-orange" onClick={this.saveAppraisalCouponProvidersOnClick}>Gönder</button>
                                    </div>
                                </>
                            }
                        </Modal>
                    </div>
                </div>
            </div>
        )
    }
}
